import { useState } from 'react';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useApi } from '@/hooks/useApi';
import { post } from '@/lib/api';

interface TimeOffRequest {
  id: string;
  employee_name: string;
  time_off_type: string;
  start_date: string;
  end_date: string;
  hours: number;
  status: string;
  reason?: string;
}

export function TimeOffPage() {
  const [status, setStatus] = useState('pending');
  const { data, loading, refetch } = useApi<{ requests: TimeOffRequest[] }>(`time-off?status=${status}`, [status]);

  async function handleAction(id: string, action: 'approve' | 'deny') {
    await post(`time-off/${id}/${action}`, action === 'deny' ? { reason: 'Scheduling conflict' } : {});
    refetch();
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <select value={status} onChange={e => setStatus(e.target.value)} className="bg-surface-2 border border-border rounded-lg px-3 py-2 text-sm text-foreground">
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="denied">Denied</option>
        </select>
      </div>
      {loading ? <div className="text-muted-foreground">Loading...</div> : (
        <DataTable
          columns={[
            { key: 'employee_name', header: 'Employee', render: (r: TimeOffRequest) => <span className="font-medium">{r.employee_name}</span> },
            { key: 'time_off_type', header: 'Type', render: (r: TimeOffRequest) => <span className="capitalize">{r.time_off_type.replace('_', ' ')}</span> },
            { key: 'start_date', header: 'Start', render: (r: TimeOffRequest) => r.start_date?.split('T')[0] ?? '' },
            { key: 'end_date', header: 'End', render: (r: TimeOffRequest) => r.end_date?.split('T')[0] ?? '' },
            { key: 'hours', header: 'Hours' },
            { key: 'status', header: 'Status', render: (r: TimeOffRequest) => <StatusBadge status={r.status} /> },
            { key: 'actions', header: '', render: (r: TimeOffRequest) => r.status === 'pending' ? (
              <div className="flex gap-2">
                <button onClick={(e) => { e.stopPropagation(); handleAction(r.id, 'approve'); }} className="px-2 py-1 bg-emerald-500/10 text-emerald-400 rounded text-xs hover:bg-emerald-500/20">Approve</button>
                <button onClick={(e) => { e.stopPropagation(); handleAction(r.id, 'deny'); }} className="px-2 py-1 bg-red-500/10 text-red-400 rounded text-xs hover:bg-red-500/20">Deny</button>
              </div>
            ) : null },
          ]}
          data={data?.requests ?? []}
        />
      )}
    </div>
  );
}
